export default __webpack_public_path__ + "static/nakji.starkware.banner-a9b19e0b50f754cadcc44d52cbebedc3.png";